import React from "react";
import { staffApi } from "@/lib/staffApi";
import { ErrorState, Skeleton } from "@/components/BookingShell";
import { SubmittedSignature } from "@/components/SubmittedSignature";
import { PractitionerSignature } from '@/components/PractitionerSignature';
import {PractitionerNotes,isPractitionerNotes} from '@/components/PractitionerNotes';
export function CustomerSubmissionModal({ id, onClose, onReviewed, onSigned }) {
    const [sub, setSub] = React.useState(null);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        staffApi.getSubmission(id)
            .then(async (r) => {
                const item = r.submission;
                if (item.signature_id && !item.signature) {
                    const signature = await staffApi.getSignature(item.signature_id);
                    item.signature = signature.image_base64;
                }
                setSub(item);
            })
            .catch((e) => setError(e?.message || "Could not load form"));
    }, [id]);

    return (
        <div role="dialog" aria-modal="true" aria-label="Completed form" className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-start justify-center p-3 overflow-y-auto" onClick={onClose}>
            <div onClick={(e) => e.stopPropagation()} className="w-full max-w-2xl my-6 rounded-2xl glass-strong border hairline p-5 space-y-4">
                <button onClick={onClose} className="text-gold text-sm">Close</button>
                {error && <ErrorState error={new Error(error)} />}
                {!sub && !error && <Skeleton className="h-32" />}

                {sub && onReviewed && <button type="button" className="rounded-full bg-gold text-navy px-4 py-2" onClick={onReviewed}>Mark as read</button>}
                {sub && (
                    <>
                        <div className="flex items-start justify-between gap-3">
                            <div>
                                <div className="text-[10px] uppercase tracking-[0.18em] text-white/45">Completed form</div>
                                <h3 className="font-serif text-white text-2xl">{sub.title_snapshot || "Completed form"}</h3>
                                <div className="text-[11px] text-white/45 mt-1">
                                    Submitted {new Date(sub.submitted_at).toLocaleString("en-GB")}
                                </div>
                            </div>
                            <button onClick={onClose} className="text-gold text-sm">Close</button>
                        </div>

                        <div className="rounded-xl border hairline p-4 bg-white/[0.02] space-y-5 max-h-[70vh] overflow-y-auto">
                            {(sub.sections_snapshot || []).map((section) => (
                                <div key={section.id}>
                                    <h4 className="font-serif text-white text-lg">{section.title}</h4>
                                    <div className="mt-2 space-y-3">
                                        {(section.fields || [])
                                            .filter((f) => !["section_heading", "informational_text"].includes(f.kind))
                                            .map((f) => {
                                                const value = sub.answers?.[f.id];
                                                return (
                                                    <div key={f.id}>
                                                        <div className="text-xs text-white/50">{f.label}</div>
                                                        <div className="text-sm text-white break-words mt-0.5">
                                                            {isPractitionerNotes(f) ? <PractitionerNotes submissionId={id} field={f} original={value} history={sub.practitioner_note_history||[]} revision={sub.practitioner_notes_revision||0}
                                                                onSaved={note=>setSub(prev=>({...prev,practitioner_note_history:[...(prev.practitioner_note_history||[]).filter(n=>n.request_id!==note.request_id),note],practitioner_notes_revision:note.revision}))}/> :
                                                             f.kind === 'signature' && (f.signer_role === 'practitioner' || /\b(practitioner|clinician|therapist|staff)\b/i.test(f.label || '')) ?
                                                                <PractitionerSignature submissionId={id} field={f} signature={(sub.practitioner_signatures || []).find(s=>s.field_id===f.id)} onSaved={signed=>{setSub(prev=>({...prev,practitioner_signatures:[...(prev.practitioner_signatures || []),signed]}));onSigned?.();}} /> :
                                                             f.kind === "signature" ? <SubmittedSignature value={value} label={f.label} /> :
                                                             Array.isArray(value) ? value.join(", ") :
                                                             value === true ? "Yes" :
                                                             value === false ? "No" :
                                                             (value ?? "—")}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            ))}

                            {sub.signature && (
                                <div>
                                    <div className="text-[10px] uppercase tracking-[0.14em] text-white/45 mb-2">Customer signature</div>
                                    <SubmittedSignature value={sub.signature} />
                                </div>
                            )}
                        </div>

                        <p className="text-[10px] text-white/40">
                            This is the form version and answers submitted by the customer.
                        </p>
                    </>
                )}
            </div>
        </div>
    );
}
